import { ValidatorFn } from '@angular/forms';
import { Validator } from '../models';

export class Validators {

    public validators = {};

    public register(name: string | Array<any>, validator?: ValidatorFn, message?: string, parameters?) {

        if (name instanceof Array) {

            for (const item of name) {
                this.register(item.name, item.validator, item.message, item.parameters ? item.parameters : null);
            }

        } else {

            if (!this.exists(name)) {
                this.validators[name] = new Validator(name, validator, message, parameters);
            } else {
                console.warn('Validator: ' + name + ' already exists.');
            }

            return this.validators[name];

        }

    }

    public remove(name: string) {

        if (this.exists(name)) {
            this.validators[name] = undefined;
        }

    }

    public get(name: string) {

        if (this.exists(name)) {

            return this.validators[name];

        } else {

            // console.warn('Validator: ' + name + ' does not exist.');

        }

        return null;

    }

    public all() {

        return this.validators;

    }

    public exists(name: string) {

        return !!this.validators[name];

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/form/classes/validators.class.ts